import styled, { css } from 'styled-components';
import theme from 'shared/assets/style/theme';
import ImageBW from '../../../../../../components/ImageBoundsWrapper';
import { isStandalonePWA } from '../../../../../../utils/mobileSupported';
import { isAndroid, isFirefox } from 'react-device-detect';

const windowHeight = window.innerHeight;

const MainContainer = styled.div`
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: center;
  flex-direction: column;
`;

const MessageContainer = styled.div`
  height: 100%;
  width: 100%;
`;

const ContentWrapper = styled.div`
  top: 1%;
  bottom: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const DividerImage = styled(ImageBW)`
  height: 22%;
  width: 100%;
  margin-top: 2%;
`;

const IconWrapper = styled.div`
  position: relative;
  width: 100%;
  bottom: 3rem;
  margin-bottom: -2rem;
`;

const VipSuccessAssetWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const VipSuccessAsset = styled.img`
  flex: 1;
  height: 220px;

  @media screen and (max-height: 650px) {
    height: 180px;
  }

  @media screen and (min-height: 900px) {
    height: 250px;
  }
`;

const MessageIcon = styled.img`
  flex: 1;
  aspect-ratio: 2;
  height: 100px;
`;

const VipPurchaseSuccessAccessText = styled.p`
  font-size: 1.5rem;
  margin-bottom: -5px;
`;

const purchaseResponseStyles = {
  headerStyles: {
    height: '10%',
    fontSize: '22px',
    fontWeight: '500',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.common[1],
    textShadowColor: theme.palette.common[25],
    textShadowOffset: { width: 0, height: '0.6px' },
    textShadowRadius: '2px',
    paddingVertical: '20px',
  },
  bodyImageStyles: {
    height: '100%',
    width: '100%',
    zIndex: 1,
  },
};

const modalStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6vh 20vw',
  zIndex: '20',
};

const successModalMainBodyStyle = {
  width: '100%',
  height: windowHeight < 780 && !isAndroid ? '60vh' : isStandalonePWA ? (isAndroid ? '63vh' : '55vh') : '50vh',
  maxHeight: windowHeight < 700 ? '540px' : '470px',
  maxWidth: '760px',
};

const successModalMainBodyStyleSmallScreen = {
  width: '100%',
  height: windowHeight < 310 && !isFirefox ? (isAndroid ? '59vh' : '56vh') : (isFirefox ? '70vh' : '65vh'),
  maxHeight: isAndroid ? '90%' : '100%',
  maxWidth: '760px',
  marginTop: windowHeight < 310 ? '12vh' : '11vh',
};

const highlightedHeaderContainerStyle = css`
  left: 0px;
`;

const highlightedHeaderHeight = css`
  margin-bottom: 8%;
`;

export {
  highlightedHeaderContainerStyle,
  highlightedHeaderHeight,
  modalStyle,
  successModalMainBodyStyle,
  successModalMainBodyStyleSmallScreen,
  purchaseResponseStyles,
  MainContainer,
  MessageContainer,
  ContentWrapper,
  DividerImage,
  IconWrapper,
  MessageIcon,
  VipSuccessAssetWrapper,
  VipSuccessAsset,
  VipPurchaseSuccessAccessText,
};

